import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingService from "@app/overviews/network-benchmarking-dashboard/benchmarkingService";
import { CompetitiveInsightsSupersetProjectConfigurations } from "@app/overviews/network-benchmarking-dashboard/manage/shared/CompetitiveInsightsSupersetProjectConfigurations";

export interface CompetitiveInsightsManageProjectsResult {
  isLoading: boolean;
  projects: CompetitiveInsightsSupersetProjectConfigurations[] | undefined;
  refetchProjects: () => Promise<void>;
}

export const COMPETITIVE_INSIGHTS_MANAGE_PROJECTS_QUERY_KEY_PREFIX = "competitive-insights-manage-projects";

export const useCompetitiveInsightsManageProjects = (userId: number | undefined): CompetitiveInsightsManageProjectsResult => {
  const benchmarkingService = useMemo(() => new BenchmarkingService(), []);

  const queryResult = useQuery<CompetitiveInsightsSupersetProjectConfigurations[]>({
    queryFn: ({ signal }) => benchmarkingService.getSupersetProjectConfigurations(signal),
    queryKey: [COMPETITIVE_INSIGHTS_MANAGE_PROJECTS_QUERY_KEY_PREFIX, userId],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  const refetchProjects = async (): Promise<void> => {
    await queryResult.refetch({ throwOnError: true });
  };

  return {
    isLoading: queryResult.isFetching,
    projects: queryResult.data,
    refetchProjects,
  };
}

export default useCompetitiveInsightsManageProjects;
